import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";

import { Draft } from "immer";

export type PromoCategoryState = Readonly<{
    readonly products: Readonly<ProductDto[]>;
}>;

const initialCounterState: PromoCategoryState = { products: <Readonly<ProductDto>[]>[] };

const promoCategoryData = createTypedReducerWithImmer(initialCounterState, {
    "SupplyLand/Promotions/ReturnGetProductsInParentCategory": (
        draft: Draft<PromoCategoryState>,
        action: { categoryId: string; products: ProductDto[] },
    ) => {
        draft.products = action.products;
    },
});

export default (reducers as any).promoCategoryData = promoCategoryData;

export type CustomState = {
    promoCategoryData: PromoCategoryState;
} & ApplicationState;

type Reducers = {
    promoCategoryData: typeof promoCategoryData;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
